export default [
  {
    id: 1,
    name: 'Government Action',
    label: 'Government Action',
    value: 'government_action',
  },
  {
    id: 2,
    name: 'Natural Disaster',
    label: 'Natural Disaster',
    value: 'natural_disaster',
  },
  {
    id: 3,
    name: 'Private Action',
    label: 'Private Action',
    value: 'private_action',
  },
  {
    id: 4,
    name: 'Not Displaced',
    label: 'Not Displaced',
    value: 'not_displaced',
  },
];
